import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { TextInput } from "../../primitives/textInput";
import { SpinButton } from "../../primitives/spinButton";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { UniformWidthStyling } from "../../primitives/utils";
const useStyles = makeStyles({
    uniformWidth: {
        ...UniformWidthStyling,
    },
});
/**
 * Wraps a text input in a property line
 * @param props - PropertyLineProps and InputProps
 * @returns property-line wrapped input component
 */
export const TextInputPropertyLine = (props) => {
    TextInputPropertyLine.displayName = "TextInputPropertyLine";
    const classes = useStyles();
    return (_jsx(PropertyLine, { ...props, children: _jsx(TextInput, { ...props, className: mergeClasses(classes.uniformWidth, props.className) }) }));
};
/**
 * Wraps a number input in a property line
 * To force integer values, use forceInt param (this is distinct from the 'step' param, which will still allow submitting an integer value. forceInt will not)
 * @param props - PropertyLineProps and InputProps
 * @returns property-line wrapped input component
 */
export const NumberInputPropertyLine = (props) => {
    NumberInputPropertyLine.displayName = "NumberInputPropertyLine";
    const classes = useStyles();
    return (_jsx(PropertyLine, { ...props, children: _jsx(SpinButton, { ...props, className: mergeClasses(classes.uniformWidth, props.className) }) }));
};
//# sourceMappingURL=inputPropertyLine.js.map